module.exports = __webpack_public_path__ + "media/18.8696f1ec.mp3";